import React from "react"
export function Train(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M6.063 16c-1.629 0-2.964-1.202-3.058-2.713L3 13.117V5.295C3 2.54 6.196 2.041 9.534 2.003L10.257 2l.755.01c3.305.08 5.86.63 5.983 3.095l.005.188v7.824c0 1.532-1.277 2.79-2.883 2.877l-.18.005h-.187L15 17.5v.5h-1.667l-1.666-2H8.525l-1.667 2H5v-.5L6.25 16h-.188zm.062-4c-.76 0-1.375.614-1.375 1.375 0 .76.614 1.375 1.375 1.375.76 0 1.375-.614 1.375-1.375 0-.76-.614-1.375-1.375-1.375zM14 12c-.76 0-1.375.614-1.375 1.375 0 .76.614 1.375 1.375 1.375.76 0 1.375-.614 1.375-1.375 0-.76-.614-1.375-1.375-1.375zm1.375-5.998H11v3.5h4.375v-3.5zM9.004 6h-4.5v3.5h4.5V6z"
        fill="currentColor"
        fillRule="nonzero"
        opacity={0.9}
        id="prefix__train"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
